module.exports = __webpack_public_path__ + "static/media/main20.7e6f0a5b.png";